import React from "react";
import ProductCommon from "@isos/feature/dist/Brochureware/components/Product";

const Product = (props) => <ProductCommon {...props} />;

export default Product;
